<div class="page-content">
    <img [src]="'/assets/intro-logo.png'" alt="">

    <div class="sublabel">FOR THE RECORD</div>

    <div class="button-container">
        <button class="custom-button" type="button" (click)="goToPage()">Explore</button>
    </div>
</div>
